import {
  AsyncPipe,
  NgClass,
  NgFor,
  NgIf,
  NgTemplateOutlet,
} from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import {
  DelegationActions,
  DelegationState,
  UserPreferencesActions,
  UserPreferencesState,
} from '@osos/shared/legacy-core';
import { DelegationPresenterModel } from '@osos/shared/types';
import {
  ComponentBase,
  FilelinkModule,
  PropertyTranslatorPipe,
} from '@osos/shared/utility';
import { tap } from 'rxjs/operators';
import { ExitDelegationButtonComponent } from './exit-delegation-button/exit-delegation-button.component';

const DEFAULT_DELEGATION_COUNT = 3;
@Component({
  selector: 'app-user-delegations',
  templateUrl: './user-delegations.component.html',
  styleUrls: ['./user-delegations.component.scss'],
  imports: [
    FilelinkModule,
    AsyncPipe,
    TranslateModule,
    NgIf,
    NgFor,
    NgTemplateOutlet,
    ExitDelegationButtonComponent,
    PropertyTranslatorPipe,
    NgClass,
  ],
})
export class UserDelegationsComponent extends ComponentBase implements OnInit {
  delegations: DelegationPresenterModel[] = [];
  activeDelegation: DelegationPresenterModel;
  allDelegations: DelegationPresenterModel[] = [];

  get hasDelegations() {
    return this.activeDelegation || !!this.delegations.length;
  }

  constructor(private store: Store) {
    super();
  }

  ngOnInit() {
    this.store.dispatch(new DelegationActions.FetchAvailableDelegations());

    this.store
      .select(DelegationState.availableDelegations)
      .pipe(
        tap((state) => {
          if (state.loaded) {
            this.prepareDelegations(state.availableDelegations);
          }
        }),
      )
      .subscribe();
  }

  prepareDelegations(delegations: DelegationPresenterModel[]) {
    delegations ??= [];
    const activeDelegationId = this.store.selectSnapshot(
      UserPreferencesState.activeDelegationId,
    );

    if (!activeDelegationId) {
      this.allDelegations = delegations;
      this.delegations = this.allDelegations.slice(0, DEFAULT_DELEGATION_COUNT);
      return;
    }

    const activeDelegation = delegations.find(
      (d) => d.id === activeDelegationId,
    );

    if (activeDelegationId && !activeDelegation) {
      // Delegation Ended Or Revoked
      this.store.dispatch(new UserPreferencesActions.SetActiveDelegation(null));
      return;
    }

    this.activeDelegation = activeDelegation;
    this.allDelegations = delegations.filter(
      (d) => d !== this.activeDelegation,
    );
    this.delegations = this.allDelegations.slice(0, DEFAULT_DELEGATION_COUNT);
  }

  setDelegation(delegation: DelegationPresenterModel) {
    if (this.activeDelegation && this.activeDelegation.id === delegation.id) {
      this.store.dispatch(new UserPreferencesActions.SetActiveDelegation(null));
      return;
    }

    this.store.dispatch(
      new UserPreferencesActions.SetActiveDelegation(delegation.id),
    );
  }
}
